module.exports = __webpack_public_path__ + "static/media/solo58.eb6d67c6.JPG";